import {
    CheckboxField,
    CheckboxListField,
    EmailField,
    NumberField,
    PasswordField,
    PriceField,
    RadioListField,
    SelectField,
    SwitchField,
    TextareaField,
    TextField
} from './fields';
import {
    ColorPickerFieldWidget,
    DatePickerFieldWidget,
    FileUploadFieldWidget,
    NestedFormFieldWidget,
    NestedListFieldWidget,
    RelationFieldWidget,
    RepeaterFieldWidget
} from './widgets';

export const availableFieldsTypes = {
    'text': TextField,
    'custom': null,
    'number': NumberField,
    'price': PriceField,
    'password': PasswordField,
    'email': EmailField,
    'textarea': TextareaField,
    'dropdown': SelectField,
    'radio_list': RadioListField,
    'checkbox': CheckboxField,
    'checkbox_list': CheckboxListField,
    'switch': SwitchField,
    'color_picker': ColorPickerFieldWidget,
    'date_picker': DatePickerFieldWidget,
    'file_upload': FileUploadFieldWidget,
    'nested_form': NestedFormFieldWidget,
    'nested_list': NestedListFieldWidget,
    'relation': RelationFieldWidget,
    'repeater': RepeaterFieldWidget,
};

export function getFieldComponentByType(type: string | keyof typeof availableFieldsTypes) {
    return type in availableFieldsTypes ?
        availableFieldsTypes[type as keyof typeof availableFieldsTypes] :
        null;
}
